export default {
  background_image: 'Hintergrundbild',
  file_too_large: 'Die Datei ist zu groß. Maximale Größe: {{max}} MB.',
  upload_failed: 'Upload fehlgeschlagen. Bitte versuchen Sie es erneut.',
};
